export default __webpack_public_path__ + "static/2017_2018_WVS INDIA CONSOLIDATED ACCOUNTS-721603b9f030ef5cca52603f7170b8c1.pdf";